/* eslint-disable no-console */
<template>
  <div>
    <div class="card z-depth-5 p-3">
      <div class="d-flex justify-content-between">
        <h4 class="text-center font-weight-bold py-3">Students Report </h4>    
        <button class="btn btn-primary btn-sm" @click.prevent="downloadCSV(csvData)">Download csv</button>
      </div>
      <div class="table-responsive">
        <table class="table table-bordered">
          <thead class="thead-dark">
            <tr>
              <th scope="col">Email</th>
              <th scope="col">First Name</th>
              <th scope="col">Last Name</th>
              <th scope="col">School</th>
              <th scope="col">Grade</th>
              <th scope="col">Points</th>
              <th scope="col">Progress</th>
              <th scope="col">Days in the platform</th>
              <th scope="col">Logged In Time</th>
              <th scope="col">Joined At</th>
              <th scope="col">Track</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="student in students" :key="student._id">
              <th>{{ student.email }}</th>
              <th>{{ student.first_name }}</th>
              <td>{{ student.last_name }}</td>
              <td>{{ student.school }}</td>
              <td>{{ student.grade }}</td>
              <td>{{ student.points }}</td>
              <td>{{ student.level || student.progress }}</td>
              <td>{{ secondsToDays(student.autonomusTime) }}</td>
              <td>{{ secondsToHms(student.autonomusTime) }}</td>
              <td>{{ miliToDate(student.date_joined) }}</td>
              <td> <button class="btn btn-primary btn-sm" @click.prevent="clickedTrack(student)">Track</button></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <mdb-container>
        <mdb-modal :show="showModal" removeBackdrop centered size="xl">
            <mdb-modal-body>
              <h4 class="text-center font-weight-bold py-3">{{this.currentStudentName}}'s Report</h4>
      <div class="table-responsive">
        <table class="table table-bordered">
          <thead class="thead-dark">
            <tr>
              <th scope="col">Title</th>
              <th scope="col">Points</th>
              <th scope="col">Passing Time</th>
              <th scope="col">Updated At</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in progresses" :key="item._id">
              <th>{{ item.title }}</th>
              <td>{{ item.points  }}</td>
              <td>{{ secondsToHms(item.time) }}</td>
              <td>{{ miliToDate(item.date) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
                <div class="modal-footer">
                    <button
                          type="button"
                          class="btn btn-danger btn-sm"
                          data-dismiss="modal"
                          @click="showModal = false"
                        >
                          Close
                    </button>
                </div>
            </mdb-modal-body>
            </mdb-modal>
    </mdb-container>
  </div>
</template>

<script>
import axios from "axios";
import { mdbContainer, mdbModal, mdbModalBody } from "mdbvue";


export default {
  name: "StudentsReport",
  components: {
    mdbContainer,
    mdbModal,
    mdbModalBody,
  },
  data() {
    return {
      students: [],
      progresses: [],
      showModal: false,
      currentStudentName: '',
      csvData: [],
      fastAdminToken: localStorage.getItem("fastAdminToken"),
    };
  },
  methods: {
    secondsToHms(d) {
      d = Number(d);
      var h = Math.floor(d / 3600);
      var m = Math.floor(d % 3600 / 60);
      var s = Math.floor(d % 3600 % 60);

      var hDisplay = h > 0 ? h + (h == 1 ? " hour " : " hours ") : "";
      var mDisplay = m > 0 ? m + (m == 1 ? " minute " : " minutes ") : "";
      var sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";
      return hDisplay + mDisplay + sDisplay; 
    },

    secondsToDays(d) {
      d = Number(d);
      var day = Math.floor(d / 3600 / 24);
      
      return day; 
    },

    miliToDate(milis) {
      var date = new Date(milis);
      return date.toLocaleString().split(',')[0];
    },

    downloadCSV(jsonData){
      const arr = typeof jsonData !== 'object' ? JSON.parse(jsonData) : jsonData;
      const str = `${Object.keys(arr[0]).map((value) => `${value}`).join(',')}\r\n`;
      const csvContent = arr.reduce((st, next) => {
        st += `${Object.values(next).map((value) => 
          `${value}`).join(',')}\r\n`;
          return st;
        }, str);
      const element = document.createElement('a');
      element.href = `data:text/csv;charset=utf8,${encodeURI(csvContent)}`;
      element.target = '_blank';
      element.download = 'export.csv';
      element.click();    
  },

  clickedTrack(student) {

      this.currentStudentName = student.first_name + ' ' + student.last_name + `(${student.email})`;

      this.progresses = [];
      this.$toast.open({
        message: "Processing : Loading Students Data Please Wait...",
        type: "info",
      });

    const config = {
      headers: {
        Authorization: "Bearer " + this.fastAdminToken,
        "Content-Type": "application/json",
      },
    };
    axios
      .get(this.$apiURI + "/progress/report/" + student._id, config)
      .then((response) => {
        if (response.data.error) {
          this.$toast.open({
            message: "Error : " + response.data.message,
            type: "error",
          });
        } else {
          // eslint-disable-next-line no-console
          // console.log(response.data.data.teachers)
          this.progresses = response.data.data.progresses;
          this.showModal = true;
        }
      })
      .catch((error) => {
        this.$toast.open({
          message: "Error : " + error.response.data.message,
          type: "error",
        });
      });

    }
  },
  mounted() {
    this.$toast.open({
      message: "Processing : Loading Students Data Please Wait...",
      type: "info",
    });

    const config = {
      headers: {
        Authorization: "Bearer " + this.fastAdminToken,
        "Content-Type": "application/json",
      },
    };
    axios
      .get(this.$apiURI + "/account/students", config)
      .then((response) => {
        if (response.data.error) {
          this.$toast.open({
            message: "Error : " + response.data.message,
            type: "error",
          });
        } else {
          // eslint-disable-next-line no-console
          // console.log(response.data.data.teachers)
          this.students = response.data.data.students.sort((a, b) => b.emmaTime - a.emmaTime);

          for (var i in this.students) {
            this.csvData.push({
              email: this.students[i].email,
              first_name: this.students[i].first_name,
              last_name: this.students[i].last_name,
              school: this.students[i].school || '',
              grade: this.students[i].grade || '',
              points: this.students[i].points,
              progress: this.students[i].level||this.students[i].progress,
              days_logged_in: this.secondsToDays(this.students[i].autonomusTime),
              time_logged_in: this.secondsToHms(this.students[i].autonomusTime),
              joined_in: this.miliToDate(this.students[i].date_joined),
            });
          }

        }
      })
      .catch((error) => {
        this.$toast.open({
          message: "Error : " + error.response.data.message,
          type: "error",
        });
      });

   
  },
};
</script>
